// components/TypingIndicator/TypingIndicator.jsx
import React from 'react';

/**
 * Componente para mostrar animación de "escribiendo" elegante
 */
export const TypingIndicator = ({ className = "" }) => {
  return (
    <div className={`flex gap-1.5 items-center ${className}`}>
      <div 
        className="w-2 h-2 bg-purple-400 rounded-full animate-bounce" 
        style={{ animationDelay: '0ms', animationDuration: '1s' }}
      ></div>
      <div 
        className="w-2 h-2 bg-purple-400 rounded-full animate-bounce" 
        style={{ animationDelay: '150ms', animationDuration: '1s' }}
      ></div>
      <div 
        className="w-2 h-2 bg-purple-400 rounded-full animate-bounce" 
        style={{ animationDelay: '300ms', animationDuration: '1s' }}
      ></div>
    </div>
  );
};

export default TypingIndicator;